// Import markdown files as raw text
import termsMarkdown from './TermsAndConditions.md?raw';
import privacyMarkdown from './PrivacyPolicy.md?raw';
import { convertMarkdownToHTML } from '../utils/markdownConverter';

// Convert markdown to HTML during build
export const legalContent = {
  terms: {
    title: 'Terms and Conditions',
    lastUpdated: new Date().toLocaleDateString(),
    content: convertMarkdownToHTML(termsMarkdown)
  },
  privacy: {
    title: 'Privacy Policy', 
    lastUpdated: new Date().toLocaleDateString(),
    content: convertMarkdownToHTML(privacyMarkdown)
  }
};

export default legalContent;
